import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import React from "react";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const QuillEditor = ({
  value,
  onChange,
  id,
  placeholder = "Write description in brief...",
}) => {
  return (
    <ReactQuill
      id={id}
      modules={modules}
      theme="snow"
      value={value}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
};

export default QuillEditor;
